import type { GameState } from './GameState';

// ============================================================================
// RESOURCE TYPES
// ============================================================================

// Centralized resource type definition
export type ResourceType = 'rawData' | 'cleanData' | 'feature' | 'model' | 'reasoningEngine' | 'researchProgress';

export class ResourceBundle {
  money?: number;
  rawData?: number;
  cleanData?: number;
  feature?: number;
  model?: number;
  reasoningEngine?: number;
  researchProgress?: number;
  agiScore?: number;
}

export class StorageCapacityBundle {
  rawData?: number;
  cleanData?: number;
  feature?: number;
  model?: number;
  reasoningEngine?: number;
  researchProgress?: number;
}

export class ProductionRateBundle {
  money?: number;
  rawData?: number;
  cleanData?: number;
  feature?: number;
  model?: number;
  reasoningEngine?: number;
  researchProgress?: number;
  agiScore?: number;
}

export class ExpenseBundle {
  talentExpensesPerSec: number = 0;
  infrastructureExpensesPerSec: number = 0;
  totalExpensesPerSec: number = 0;
}

export class PersonnelBundle {
  dataEngineer?: number;
  mlEngineer?: number;
  aiResearcher?: number;
  reasoningSpecialist?: number;
  agiSafetyResearcher?: number;
}

export class InfrastructureBundle {
  webScraper?: number;
  database?: number;
  cleanDataApi?: number;
  iotSensor?: number;
  dataLake?: number;
  dataWarehouse?: number;
  dataLakehouse?: number;

  // Processing components
  dataCleaner?: number;
  etlPipeline?: number;
  streamingSystem?: number;

  // Feature Engineering Infrastructure
  featureStore?: number;
  featurePipeline?: number;

  // Model Training Infrastructure
  trainingPipeline?: number;
  modelRegistry?: number;
  modelApi?: number;

  // Reasoning Infrastructure
  reasoningInferenceStorage?: number;

  // AGI Infrastructure
  agiCluster?: number;
}

export class LifetimeStatsBundle {
  maxMoney: number = 0;
  totalRawDataCollected: number = 0;
  totalCleanDataProduced: number = 0;
  totalFeaturesEngineered: number = 0;
  totalModelsBuilt: number = 0;
  totalReasoningEnginesBuilt: number = 0;
  totalInfrastructureBuilt: number = 0;
  totalPersonnelHired: number = 0;
}

export interface UpgradeRequirements {
  upgrades?: string[];
  personnel?: PersonnelBundle;
  infrastructure?: InfrastructureBundle;
  resources?: ResourceBundle;
}

// ============================================================================
// ENTITY TYPES
// ============================================================================

export interface BaseEntity {
  id: string;
  name: string;
  description: string;
}


export interface Achievement extends BaseEntity {
  condition: (state: GameState) => boolean;
}

export interface GameEngine {
  state: GameState;
  log(message: string, type: 'info' | 'success' | 'warning' | 'error'): void;
}

export interface Event extends BaseEntity {
    probability: number,
    duration: number,
    condition: (gameState: GameState) => boolean,
    effect: (game: GameEngine) => void,
} 